import LocationSearchBox from "./locationSearchBox.molecule";

export default LocationSearchBox;
